import React, { useState } from 'react'
import { Col, Row, Form, Input, Button, Select, Alert ,notification} from 'antd';
import axios from 'axios';
import ReCAPTCHA from "react-google-recaptcha";


const CheckoutFormTwo = (props) => {
    const [success, setSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const recaptchaRef = React.createRef();
    
    function captchaChange(value) {
        console.log("Captcha value:", value);
    }
    const handleSubmit = async customerInfo => {
            customerInfo.merchant = props.merchant
            setSubmitting(true)
            console.log("customerInfo =>",customerInfo);
            const url = `${props.apiUrl}/subscriber/marketing`;
            const response = await axios.post(url, customerInfo);
            if(response.status === 200){
                setSuccess(true)    
            }
            else{
                notification.error({  message: response.data.message})
            }
            setSubmitting(false)
    }
    return (
        success ?
            <Alert message={"You are successfully Subscriber!"} type={"success"} />
            :
        
            <Form
               layout={"vertical"}
               className="formcss"
                // style={{ maxWidth: 1000, margin: 'auto', color: 'black !important;' }}
                onFinishFailed={() => { }}
                onFinish={handleSubmit}
            >
                <Input.Group size="large">
                    <Form.Item
                        // style={{ color: 'black' ,fontSize:"25px"}}
                        name={"phoneNumber"}
                        className="fontcss"
                        label={"Cell phone number"}
                        rules={[{ required: true, message: 'Fill in your cell phone number.' }]}
                    >
                        <Input  type="tel" prefix={"+1"} placeholder={"Cell phone number"} />
                    </Form.Item>
                </Input.Group>
                {/* <h3>Where can we ship it to you?</h3> */}
                <Input.Group size="large">
                    {/* <Row gutter={12}>
                        <Col span={12}> */}
                            <Form.Item
                            className="fontcss"
                                // style={{ color: 'black' ,fontSize:"25px !important"}}
                                name={"firstName"}
                                label={"First name"}
                                rules={[{ required: true, message: 'Fill in your first name.' }]}
                            >
                                <Input  placeholder={"First name"} />
                            </Form.Item>
                        {/* </Col>
                        <Col span={12}>
                            <Form.Item
                                style={{ color: 'black' }}
                                name={"lastName"}
                                label={"Last name"}
                                rules={[{ required: true, message: 'Fill in your last name.' }]}
                            >
                                <Input   placeholder={"Last name"} />
                            </Form.Item>
                        </Col>
                    </Row> */}
                </Input.Group>
                <Input.Group size="large">
                    {/* <Row gutter={12}>
                        <Col span={12}>
                            <Form.Item
                                style={{ color: 'black' }}
                                name={"firstName"}
                                label={"First name"}
                                rules={[{ required: true, message: 'Fill in your first name.' }]}
                            >
                                <Input  placeholder={"First name"} />
                            </Form.Item>
                        </Col> */}
                       
                            <Form.Item
                            className="fontcss"
                                // style={{ color: 'black',fontSize:"25px" }}
                                name={"lastName"}
                                label={"Last name"}
                                rules={[{ required: true, message: 'Fill in your last name.' }]}
                            >
                                <Input   placeholder={"Last name"} />
                            </Form.Item>
                      
                </Input.Group>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey="6LcYyygaAAAAAFz0Tw3z0E9ai4VuDpXX4Z0S1Dj4"
                    onChange={captchaChange}
                />
                <Form.Item
                    style={{ color: 'black' }}>
                    <Button
                        loading={submitting}
                        htmlType={"submit"}
                        className="btncss"
                        block
                        type={"primary"}
                        size={"large"}
                    >
                        Sign Up
                </Button>
                </Form.Item>
                <div style={{ textAlign: 'center' }} className="mainpdiv">
                  
                    <p className='peracss'>You are subscribing to receive promotional text messages (MMS {"&"} SMS).</p>
                    {/* <p>Message {"&"} data rates may apply.</p> */}
                </div>
            </Form>
         
            
    )
}

export default CheckoutFormTwo